/* =========================================
   MUBLIG Custom Search
   Datei: assets/mublig-search.js

   Funktionen:
   - Shopify Predictive Search
   - Suchvorschläge + Produkte
   - Fuzzy-Korrektur auf Basis echter Menübegriffe
   - Tippfehler-Toleranz ohne starre Fehlerliste
   ========================================= */

(function () {
  if (window.__mubligCustomSearchLoaded) return;
  window.__mubligCustomSearchLoaded = true;

  var MENU_TERMS_CACHE = null;

  function debounce(fn, delay) {
    var timer;

    return function () {
      var context = this;
      var args = arguments;

      window.clearTimeout(timer);

      timer = window.setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function cleanBaseUrl(baseUrl) {
    if (baseUrl) {
      return String(baseUrl).replace(/\.json$/, '').replace(/\/$/, '');
    }

    return getShopifyRoot().replace(/\/$/, '') + '/search/suggest';
  }

  function buildPredictiveUrl(baseUrl, query) {
    var url = cleanBaseUrl(baseUrl) + '.json';
    var params = new URLSearchParams();

    params.set('q', query);
    params.set('resources[type]', 'product,collection,query');
    params.set('resources[limit]', '6');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'show');
    params.set(
      'resources[options][fields]',
      'title,product_type,variants.title,vendor,tag,variants.sku'
    );

    return url + '?' + params.toString();
  }

  function normalizeTerm(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' und ')
      .replace(/\+/g, ' ')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function removeGenericWords(value) {
    return normalizeTerm(value)
      .replace(/\b(alle|moebel|mobel|fuer|fur|und|set|sets|der|die|das|mit)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fuzzyKey(value) {
    return removeGenericWords(value)
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u')
      .replace(/ck/g, 'k')
      .replace(/dt/g, 't')
      .split(' ')
      .map(function (word) {
        if (word.length > 5 && word.endsWith('en')) return word.slice(0, -2);
        if (word.length > 5 && word.endsWith('e')) return word.slice(0, -1);
        if (word.length > 5 && word.endsWith('n')) return word.slice(0, -1);

        return word;
      })
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function levenshtein(a, b) {
    a = normalizeTerm(a);
    b = normalizeTerm(b);

    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;

    var matrix = [];
    var i;
    var j;
    var row;
    var col;

    for (i = 0; i <= b.length; i += 1) {
      matrix[i] = [i];
    }

    for (j = 0; j <= a.length; j += 1) {
      matrix[0][j] = j;
    }

    for (row = 1; row <= b.length; row += 1) {
      for (col = 1; col <= a.length; col += 1) {
        if (b.charAt(row - 1) === a.charAt(col - 1)) {
          matrix[row][col] = matrix[row - 1][col - 1];
        } else {
          matrix[row][col] = Math.min(
            matrix[row - 1][col - 1] + 1,
            matrix[row][col - 1] + 1,
            matrix[row - 1][col] + 1
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }

  function similarity(a, b) {
    a = fuzzyKey(a);
    b = fuzzyKey(b);

    if (!a || !b) return 0;
    if (a === b) return 1;

    var distance = levenshtein(a, b);
    var maxLength = Math.max(a.length, b.length);

    if (!maxLength) return 0;

    return 1 - distance / maxLength;
  }

  function intentBoost(queryKey, termKey) {
    var boost = 0;

    if (queryKey === 'schrank') {
      if (
        termKey.indexOf('kleiderschrank') !== -1 ||
        termKey.indexOf('kleider schrank') !== -1
      ) {
        boost += 0.24;
      }

      if (termKey.indexOf('tv') !== -1) {
        boost -= 0.12;
      }

      if (termKey.indexOf('badezimmer') !== -1) {
        boost += 0.04;
      }
    }

    return boost;
  }

  function hasProducts(data) {
    var results =
      data && data.resources && data.resources.results
        ? data.resources.results
        : {};

    return !!(results.products && results.products.length);
  }

  function hasStrongOriginalMatch(data, query) {
    var rawQuery = normalizeTerm(query);

    if (!rawQuery || rawQuery.length < 3) return false;

    var results =
      data && data.resources && data.resources.results
        ? data.resources.results
        : {};

    var texts = [];

    (results.products || []).forEach(function (product) {
      texts.push(product.title || '');
      texts.push(product.vendor || '');
      texts.push(product.product_type || '');
      texts.push(product.type || '');
    });

    (results.collections || []).forEach(function (collection) {
      texts.push(collection.title || '');
    });

    (results.queries || []).forEach(function (item) {
      texts.push(item.text || item.title || '');
    });

    return texts.some(function (text) {
      return normalizeTerm(text).indexOf(rawQuery) !== -1;
    });
  }

  function shouldTryFuzzySearch(originalQuery, fuzzyTerm, data) {
    if (!fuzzyTerm) return false;

    var originalKey = fuzzyKey(originalQuery);
    var fuzzyTermKey = fuzzyKey(fuzzyTerm);

    if (!originalKey || !fuzzyTermKey) return false;
    if (originalKey === fuzzyTermKey) return false;

    if (!hasProducts(data)) return true;

    if (!hasStrongOriginalMatch(data, originalQuery)) return true;

    if (originalKey === 'schrank' && fuzzyTermKey.indexOf('kleiderschrank') !== -1) {
      return true;
    }

    return false;
  }

  function readMenuSearchTermsFromDom() {
    var terms = [];
    var selectors = [
      '.mublig-mega__room-title',
      '.mublig-mega__item strong',
      '.header__menu .btn-text',
      '.header__menu a',
      '.header__menu summary'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        var text = String(element.textContent || '').replace(/\s+/g, ' ').trim();

        if (text && text.length >= 3) {
          terms.push(text);
        }
      });
    });

    return terms;
  }

  function expandMenuTerms(terms) {
    var expanded = [];
    var seen = {};

    (terms || []).forEach(function (term) {
      var clean = removeGenericWords(term);

      if (!clean || clean.length < 3) return;

      expanded.push(term);
      expanded.push(clean);

      clean.split(' ').forEach(function (word) {
        if (word.length >= 4) {
          expanded.push(word);
        }
      });

      if (clean.endsWith('en') && clean.length > 5) {
        expanded.push(clean.slice(0, -2));
      }

      if (clean.endsWith('e') && clean.length > 5) {
        expanded.push(clean.slice(0, -1));
      }
    });

    return expanded.filter(function (term) {
      var key = removeGenericWords(term);

      if (!key || key.length < 3 || seen[key]) return false;

      seen[key] = true;
      return true;
    });
  }

  function getMenuSearchTerms(forceRefresh) {
    if (MENU_TERMS_CACHE && !forceRefresh) {
      return MENU_TERMS_CACHE;
    }

    MENU_TERMS_CACHE = expandMenuTerms(readMenuSearchTermsFromDom());

    return MENU_TERMS_CACHE;
  }

  function findBestFuzzyTerm(query) {
    var cleanQuery = removeGenericWords(query);
    var queryKey = fuzzyKey(cleanQuery);

    if (!queryKey || queryKey.length < 4) return null;

    var terms = getMenuSearchTerms();
    var best = null;

    terms.forEach(function (term) {
      var cleanTerm = removeGenericWords(term);
      var termKey = fuzzyKey(cleanTerm);
      var score;
      var queryWords;
      var termWords;

      if (!termKey || termKey.length < 4) return;

      score = similarity(queryKey, termKey);

      if (termKey.indexOf(queryKey) !== -1 || queryKey.indexOf(termKey) !== -1) {
        score += 0.18;
      }

      queryWords = queryKey.split(' ');
      termWords = termKey.split(' ');

      queryWords.forEach(function (queryWord) {
        termWords.forEach(function (termWord) {
          var wordScore;

          if (queryWord.length < 4 || termWord.length < 4) return;

          wordScore = similarity(queryWord, termWord);

          if (termWord.indexOf(queryWord) !== -1 || queryWord.indexOf(termWord) !== -1) {
            wordScore += 0.14;
          }

          if (termWord.endsWith(queryWord) || queryWord.endsWith(termWord)) {
            wordScore += 0.18;
          }

          if (wordScore > score) {
            score = wordScore - 0.03;
          }
        });
      });

      score += intentBoost(queryKey, termKey);

      if (!best || score > best.score) {
        best = {
          original: term,
          clean: cleanTerm,
          key: termKey,
          score: score
        };
      }
    });

    if (!best) return null;

    return best.score >= (queryKey.length <= 5 ? 0.72 : 0.66)
      ? best.original
      : null;
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';

    if (typeof value === 'string' && value.match(/[€$£]/)) {
      return escapeHtml(value);
    }

    var number = Number(value);

    if (Number.isNaN(number)) {
      return escapeHtml(value);
    }

    if (number > 1000 && Number.isInteger(number)) {
      number = number / 100;
    }

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(number);
  }

  function getProductImage(product) {
    if (!product) return '';

    if (product.featured_image && product.featured_image.url) {
      return product.featured_image.url;
    }

    if (product.featured_image && typeof product.featured_image === 'string') {
      return product.featured_image;
    }

    if (
      product.featured_media &&
      product.featured_media.preview_image &&
      product.featured_media.preview_image.url
    ) {
      return product.featured_media.preview_image.url;
    }

    if (product.image && product.image.url) {
      return product.image.url;
    }

    if (product.image && typeof product.image === 'string') {
      return product.image;
    }

    return '';
  }

  function getProductPrice(product) {
    if (!product) return '';

    return (
      product.price_min ||
      product.price ||
      product.compare_at_price_min ||
      product.compare_at_price ||
      ''
    );
  }

  function getProductMeta(product) {
    if (!product) return 'MUBLIG';

    return product.vendor || product.product_type || product.type || 'MUBLIG';
  }

  function renderSuggestions(queries, collections) {
    var html = [];

    (queries || []).slice(0, 6).forEach(function (item) {
      var title = item.text || item.title || '';
      var url = item.url || '/search?q=' + encodeURIComponent(title);

      if (!title) return;

      html.push(
        '<a class="mublig-search__suggestion" href="' + escapeHtml(url) + '">' +
          escapeHtml(title) +
        '</a>'
      );
    });

    (collections || []).slice(0, 4).forEach(function (item) {
      var title = item.title || '';
      var url = item.url || '#';

      if (!title) return;

      html.push(
        '<a class="mublig-search__suggestion" href="' + escapeHtml(url) + '">' +
          escapeHtml(title) +
        '</a>'
      );
    });

    if (!html.length) {
      html.push(
        '<span class="mublig-search__suggestion mublig-search__suggestion--empty">' +
          'Keine Vorschläge' +
        '</span>'
      );
    }

    return html.join('');
  }

  function renderProducts(products) {
    if (!products || !products.length) {
      return (
        '<div class="mublig-search__empty">' +
          'Keine passenden Produkte gefunden.' +
        '</div>'
      );
    }

    return products.slice(0, 6).map(function (product) {
      var image = getProductImage(product);
      var price = getProductPrice(product);
      var meta = getProductMeta(product);
      var title = product.title || '';
      var url = product.url || '#';

      return (
        '<a class="mublig-search__product" href="' + escapeHtml(url) + '">' +

          '<span class="mublig-search__product-image-wrap">' +
            (
              image
                ? '<img class="mublig-search__product-image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy">'
                : '<span class="mublig-search__product-image mublig-search__product-image--empty"></span>'
            ) +
          '</span>' +

          '<span class="mublig-search__product-info">' +
            '<strong class="mublig-search__product-title">' + escapeHtml(title) + '</strong>' +
            '<small class="mublig-search__product-meta">' + escapeHtml(meta) + '</small>' +
          '</span>' +

          '<span class="mublig-search__price">' +
            formatMoney(price) +
          '</span>' +

        '</a>'
      );
    }).join('');
  }

  function renderResults(search, originalQuery, usedQuery, data, wasCorrected) {
    var results =
      data && data.resources && data.resources.results
        ? data.resources.results
        : {};

    var products = results.products || [];
    var queries = results.queries || [];
    var collections = results.collections || [];
    var allUrl = search.searchUrl + '?q=' + encodeURIComponent(usedQuery);
    var correctionNotice = '';

    if (wasCorrected && normalizeTerm(originalQuery) !== normalizeTerm(usedQuery)) {
      correctionNotice =
        '<div class="mublig-search__notice">' +
          'Ergebnisse für <strong>' + escapeHtml(usedQuery) + '</strong>' +
          '<span> statt „' + escapeHtml(originalQuery) + '“</span>' +
        '</div>';
    }

    search.content.innerHTML =
      '<aside class="mublig-search__side">' +
        '<h3 class="mublig-search__heading">Suchvorschläge</h3>' +
        '<div class="mublig-search__suggestions">' +
          renderSuggestions(queries, collections) +
        '</div>' +
      '</aside>' +

      '<main class="mublig-search__main">' +
        '<div class="mublig-search__main-head">' +
          '<h3 class="mublig-search__heading">Produkte</h3>' +
          '<a class="mublig-search__all" href="' + escapeHtml(allUrl) + '">Alle Ergebnisse →</a>' +
        '</div>' +
        correctionNotice +
        '<div class="mublig-search__products">' +
          renderProducts(products) +
        '</div>' +
      '</main>';
  }

  function initSearch(root) {
    var input = root.querySelector('.mublig-search__input');
    var panel = root.querySelector('.mublig-search__panel');
    var content = root.querySelector('.mublig-search__content');

    if (!input || !panel || !content) return;

    var search = {
      root: root,
      input: input,
      panel: panel,
      content: content,
      predictiveUrl: root.dataset.predictiveUrl || '',
      searchUrl: root.dataset.searchUrl || '/search',
      controller: null
    };

    function openPanel() {
      panel.hidden = false;
      root.classList.add('is-open');
    }

    function closePanel() {
      panel.hidden = true;
      root.classList.remove('is-open', 'is-loading');
    }

    function showLoading() {
      root.classList.add('is-loading');
      openPanel();
    }

    function hideLoading() {
      root.classList.remove('is-loading');
    }

    function fetchSearch(query) {
      return fetch(buildPredictiveUrl(search.predictiveUrl, query), {
        signal: search.controller.signal,
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search failed: ' + response.status);
        }

        return response.json();
      });
    }

    function performSearch() {
      var originalQuery = input.value.trim();

      if (originalQuery.length < 2) {
        closePanel();
        return;
      }

      if (search.controller) {
        search.controller.abort();
      }

      search.controller = new AbortController();

      showLoading();

      fetchSearch(originalQuery)
        .then(function (data) {
          var fuzzyTerm = findBestFuzzyTerm(originalQuery);

          if (!shouldTryFuzzySearch(originalQuery, fuzzyTerm, data)) {
            hideLoading();
            renderResults(search, originalQuery, originalQuery, data, false);
            return null;
          }

          return fetchSearch(fuzzyTerm).then(function (fuzzyData) {
            hideLoading();

            if (hasProducts(fuzzyData)) {
              renderResults(search, originalQuery, fuzzyTerm, fuzzyData, true);
            } else {
              renderResults(search, originalQuery, originalQuery, data, false);
            }

            return null;
          });
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;

          hideLoading();

          content.innerHTML =
            '<div class="mublig-search__empty">' +
              'Die Suche konnte gerade nicht geladen werden.' +
            '</div>';
        });
    }

    input.addEventListener('input', debounce(performSearch, 220));

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) {
        performSearch();
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePanel();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) {
        closePanel();
      }
    });
  }

  function initAllSearches(forceRefreshTerms) {
    getMenuSearchTerms(!!forceRefreshTerms);

    document.querySelectorAll('.mublig-search').forEach(function (root) {
      if (root.dataset.mubligSearchReady === 'true') return;

      root.dataset.mubligSearchReady = 'true';

      initSearch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSearches(true);
    });
  } else {
    initAllSearches(true);
  }

  document.addEventListener('shopify:section:load', function () {
    MENU_TERMS_CACHE = null;
    initAllSearches(true);
  });
})();